import { useState, useEffect } from 'react'

import styles from './styles.module.css'

export const ClearAllFilters = ({ selectedFilters, onClearFilters = () => {}, setShowBannerButton }) => {
  const [isClearAllShown, setIsClearAllShown] = useState(false)

  useEffect(() => {
    setIsClearAllShown(Object.keys(selectedFilters).length !== 0)
  }, [selectedFilters])

  const handleOnClick = () => {
    onClearFilters({})
    setShowBannerButton(true)
  }

  return (
    <button
      name='clear_filters'
      value='all'
      onClick={handleOnClick}
      className={styles.clearAllButton}
      data-shown={isClearAllShown}
    >
      Clear all filters
    </button>
  )
}
